import { useEffect } from 'react';

let componentsCount = 0;

const HideIntercom = () => {
  useEffect(() => {
    if (!window.Intercom) {
      return () => {};
    }

    componentsCount++;
    if (componentsCount === 1) {
      window.Intercom('update', {
        hide_default_launcher: true,
      });

      // When opening website for the first time, a nasty message bubble is shown.
      // I couldn't find a more reliable way to hide it :(
      document
        .querySelector('iframe[name="intercom-chat-frame"]')
        ?.contentWindow.document.querySelector('[aria-label="Clear"]')
        ?.click();
    }

    return () => {
      componentsCount--;
      if (componentsCount === 0) {
        window.Intercom('update', {
          hide_default_launcher: false,
        });
      }
    };
  }, []);

  return <style>{`#intercom-container { display: none !important; }`}</style>;
};

export default HideIntercom;
